export default __webpack_public_path__ + "static/1757-739e639ce1a7fab40123fd01b08f18bc.gif";